import axios from "axios";
import { useEffect } from "react";

export default function useAxiosIntercept() {
    // @ts-ignore

    useEffect(() => {
        axios.interceptors.request.use(
            (config) => {
                // Get req url & query params
                const url = new URL(config.url!);
                const queryParams = new URLSearchParams(url.search);
                const newParams = new URLSearchParams();
                // Get params without null values
                queryParams.forEach(
                    (val, key) =>
                        val !== "null" && val !== "undefined" && newParams.append(key, val)
                );
                // Use new values
                config.url = `${url.origin}${url.pathname}?${newParams}`;

                const token = window.localStorage.getItem("token");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }

                return config;
            },
            (error) => Promise.reject(error)
        );
    }, []);

    return;
}
